import React from 'react';
import { useProjects } from '../hooks/useProjects';
import ProjectCard from '../components/ProjectCard';
import Footer from '../components/Footer';

const Home = () => {
  const { projects, loading } = useProjects();

  return (
    <>
      {/* CONDENSED HERO SECTION */}
      <header style={{ 
         
        textAlign: 'left', 
        maxWidth: '700px', 
        marginBottom: '20px' 
      }}>
    
        <p style={{ 
          color: '#bcd4f3', 
          fontSize: '0.95rem', // Smaller text for elegance
          lineHeight: '1.5',
          maxWidth: '550px',
          margin: 0
        }}>
          I'm a developer who actually cares about the details. I spend my time turning messy ideas into clean, fast, and usable apps. If I'm not coding, I'm
           probably figuring out how to make something run 10% faster. Take a look at what I've been building lately.
        </p>
      </header>

      {/* TIGHTER PROJECT GRID */}
      <div className="project-grid" style={{ gap: '20px' }}> {/* Reduced gap between cards */}
        {loading ? (
          <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '60px 0' }}>
            <p className="shimmer-text" style={{ color: '#64748b', fontSize: '14px' }}>Loading masterpiece...</p>
          </div>
        ) : (
          projects.map(p => <ProjectCard key={p.id} project={p} />)
        )}
      </div>

      <Footer />
    </>
  );
};

export default Home;